var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2834.65 2834.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #58595b;\n        stroke-width: 160px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 2834.65,
    height: 2834.65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M732.64,563.41h-14.98c-178.93,0-323.98,144.83-323.98,323.49v1508.26c0,178.66,145.05,323.49,323.98,323.49h948.99c178.93,0,323.98-144.83,323.98-323.49v-15.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 844.01,
    y: 112.43,
    width: 1596.96,
    height: 2155.23,
    rx: 240,
    ry: 240
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyUi);
export default __webpack_public_path__ + "static/media/copy_ui.520eb13ab83d875b070b62528a4cf98b.svg";
export { ForwardRef as ReactComponent };